export default __webpack_public_path__ + "//i/components/system-edition//OnePortal.png";